var _g, _g2, _rect, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarfieldMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 598,
    viewBox: "0 0 393 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_890_9291)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_890_9291)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.0729,
    cy: 244.939,
    r: 0.780975,
    transform: "rotate(90.19 13.0729 244.939)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.269,
    cy: 454.823,
    r: 0.536569,
    transform: "rotate(90.19 336.269 454.823)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.716,
    cy: 106.03,
    r: 0.580716,
    transform: "rotate(90.19 224.716 106.03)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.433,
    cy: 108.604,
    r: 0.482412,
    transform: "rotate(90.19 166.433 108.604)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.049,
    cy: 501.644,
    r: 0.408837,
    transform: "rotate(90.19 203.049 501.644)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.626,
    cy: 180.991,
    r: 0.774477,
    transform: "rotate(90.19 357.626 180.991)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.108,
    cy: 188.154,
    r: 0.759255,
    transform: "rotate(90.19 307.108 188.154)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.974,
    cy: 327.169,
    r: 0.685273,
    transform: "rotate(90.19 320.974 327.169)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.498,
    cy: 9.07259,
    r: 0.564436,
    transform: "rotate(90.19 142.498 9.07259)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.251,
    cy: 153.947,
    r: 0.621269,
    transform: "rotate(90.19 229.251 153.947)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.807,
    cy: 147.92,
    r: 0.58728,
    transform: "rotate(90.19 371.807 147.92)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7682,
    cy: 422.517,
    r: 0.787798,
    transform: "rotate(90.19 82.7682 422.517)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.288,
    cy: 451.224,
    r: 0.588964,
    transform: "rotate(90.19 207.288 451.224)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.714,
    cy: 404.716,
    r: 0.452299,
    transform: "rotate(90.19 161.714 404.716)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.50501,
    cy: 533.936,
    r: 0.788769,
    transform: "rotate(90.19 8.50501 533.936)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.475,
    cy: 147.879,
    r: 0.631754,
    transform: "rotate(90.19 189.475 147.879)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.4855,
    cy: 460.724,
    r: 0.527875,
    transform: "rotate(90.19 56.4855 460.724)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.391,
    cy: 397.683,
    r: 0.612323,
    transform: "rotate(90.19 236.391 397.683)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.558,
    cy: 487.135,
    r: 0.449316,
    transform: "rotate(90.19 67.558 487.135)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.733,
    cy: 251.676,
    r: 0.690286,
    transform: "rotate(90.19 311.733 251.676)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.145,
    cy: 431.285,
    r: 0.448553,
    transform: "rotate(90.19 208.145 431.285)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.108,
    cy: 412.534,
    r: 0.538863,
    transform: "rotate(90.19 349.108 412.534)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.042,
    cy: 329.957,
    r: 0.432544,
    transform: "rotate(90.19 338.042 329.957)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.3595,
    cy: 504.938,
    r: 0.643787,
    transform: "rotate(90.19 21.3595 504.938)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5129,
    cy: 453.365,
    r: 0.582342,
    transform: "rotate(90.19 91.5129 453.365)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.065,
    cy: 250.284,
    r: 0.598075,
    transform: "rotate(90.19 332.065 250.284)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.896,
    cy: 390.985,
    r: 0.734767,
    transform: "rotate(90.19 204.896 390.985)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.24,
    cy: 389.067,
    r: 0.767344,
    transform: "rotate(90.19 383.24 389.067)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.118,
    cy: 166.57,
    r: 0.625111,
    transform: "rotate(90.19 318.118 166.57)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.744,
    cy: 394.73,
    r: 0.674571,
    transform: "rotate(90.19 266.744 394.73)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.025,
    cy: 432.554,
    r: 0.587176,
    transform: "rotate(90.19 349.025 432.554)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.611,
    cy: 520.217,
    r: 0.703291,
    transform: "rotate(90.19 357.611 520.217)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.12,
    cy: 112.33,
    r: 0.412089,
    transform: "rotate(90.19 340.12 112.33)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.75,
    cy: 356.308,
    r: 0.715885,
    transform: "rotate(90.19 128.75 356.308)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.7847,
    cy: 436.711,
    r: 0.440851,
    transform: "rotate(90.19 98.7847 436.711)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.134,
    cy: 264.994,
    r: 0.77189,
    transform: "rotate(90.19 110.134 264.994)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0455,
    cy: 522.492,
    r: 0.456456,
    transform: "rotate(90.19 41.0455 522.492)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.71,
    cy: 295.416,
    r: 0.539691,
    transform: "rotate(90.19 340.71 295.416)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.088,
    cy: 196.595,
    r: 0.531728,
    transform: "rotate(90.19 135.088 196.595)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8834,
    cy: 461.071,
    r: 0.398435,
    transform: "rotate(90.19 36.8834 461.071)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.657,
    cy: 145.517,
    r: 0.615365,
    transform: "rotate(90.19 112.657 145.517)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.787,
    cy: 206.072,
    r: 0.48357,
    transform: "rotate(90.19 281.787 206.072)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.94,
    cy: 180.175,
    r: 0.701545,
    transform: "rotate(90.19 208.94 180.175)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.757,
    cy: 13.8626,
    r: 0.428273,
    transform: "rotate(90.19 307.757 13.8626)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.593,
    cy: 545.798,
    r: 0.649547,
    transform: "rotate(90.19 268.593 545.798)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.981,
    cy: 500.765,
    r: 0.69618,
    transform: "rotate(90.19 168.981 500.765)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.167,
    cy: 2.08795,
    r: 0.499522,
    transform: "rotate(90.19 296.167 2.08795)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.657,
    cy: 28.1359,
    r: 0.431404,
    transform: "rotate(90.19 146.657 28.1359)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.852,
    cy: 523.025,
    r: 0.45753,
    transform: "rotate(90.19 365.852 523.025)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.467,
    cy: 274.474,
    r: 0.469689,
    transform: "rotate(90.19 332.467 274.474)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.668,
    cy: 65.7381,
    r: 0.708184,
    transform: "rotate(90.19 100.668 65.7381)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.202,
    cy: 299.136,
    r: 0.511894,
    transform: "rotate(90.19 113.202 299.136)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.333,
    cy: 412.535,
    r: 0.553363,
    transform: "rotate(90.19 180.333 412.535)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.6383,
    cy: 113.638,
    r: 0.471016,
    transform: "rotate(90.19 45.6383 113.638)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5207,
    cy: 541.479,
    r: 0.596503,
    transform: "rotate(90.19 79.5207 541.479)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.1602,
    cy: 111.753,
    r: 0.484695,
    transform: "rotate(90.19 53.1602 111.753)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.925,
    cy: 338.525,
    r: 0.661671,
    transform: "rotate(90.19 208.925 338.525)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.106,
    cy: 177.957,
    r: 0.757512,
    transform: "rotate(90.19 308.106 177.957)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.187,
    cy: 400.716,
    r: 0.637115,
    transform: "rotate(90.19 265.187 400.716)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.054,
    cy: 279.67,
    r: 0.779836,
    transform: "rotate(90.19 128.054 279.67)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.201,
    cy: 488.631,
    r: 0.764152,
    transform: "rotate(90.19 383.201 488.631)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.714,
    cy: 16.0684,
    r: 0.61761,
    transform: "rotate(90.19 223.714 16.0684)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.2164,
    cy: 399.732,
    r: 0.447121,
    transform: "rotate(90.19 41.2164 399.732)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.25,
    cy: 359.309,
    r: 0.667205,
    transform: "rotate(90.19 112.25 359.309)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.54923,
    cy: 167.809,
    r: 0.432739,
    transform: "rotate(90.19 5.54923 167.809)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.93291,
    cy: 170.335,
    r: 0.527746,
    transform: "rotate(90.19 4.93291 170.335)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.0476,
    cy: 106.929,
    r: 0.699138,
    transform: "rotate(90.19 63.0476 106.929)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.916,
    cy: 467.383,
    r: 0.68927,
    transform: "rotate(90.19 363.916 467.383)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.147,
    cy: 165.704,
    r: 0.619957,
    transform: "rotate(90.19 115.147 165.704)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.556,
    cy: 84.8427,
    r: 0.627944,
    transform: "rotate(90.19 123.556 84.8427)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0664,
    cy: 26.4314,
    r: 0.760137,
    transform: "rotate(90.19 41.0664 26.4314)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.384,
    cy: 53.1384,
    r: 0.749617,
    transform: "rotate(90.19 245.384 53.1384)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.162,
    cy: 127.349,
    r: 0.541795,
    transform: "rotate(90.19 381.162 127.349)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.697,
    cy: 454.834,
    r: 0.518849,
    transform: "rotate(90.19 112.697 454.834)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.604,
    cy: 289.394,
    r: 0.497497,
    transform: "rotate(90.19 143.604 289.394)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.325,
    cy: 300.872,
    r: 0.751719,
    transform: "rotate(90.19 294.325 300.872)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.618,
    cy: 191.136,
    r: 0.569331,
    transform: "rotate(90.19 175.618 191.136)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.775,
    cy: 503.3,
    r: 0.469353,
    transform: "rotate(90.19 116.775 503.3)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.37,
    cy: 516.787,
    r: 0.442206,
    transform: "rotate(90.19 115.37 516.787)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5283,
    cy: 299.1,
    r: 0.472571,
    transform: "rotate(90.19 31.5283 299.1)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.348,
    cy: 104.749,
    r: 0.630978,
    transform: "rotate(90.19 378.348 104.749)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.006,
    cy: 266.443,
    r: 0.545854,
    transform: "rotate(90.19 241.006 266.443)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.329,
    cy: 2.48337,
    r: 0.55708,
    transform: "rotate(90.19 213.329 2.48337)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.032,
    cy: 343.831,
    r: 0.493233,
    transform: "rotate(90.19 171.032 343.831)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.415,
    cy: 409.503,
    r: 0.642936,
    transform: "rotate(90.19 11.415 409.503)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.392,
    cy: 84.6503,
    r: 0.694606,
    transform: "rotate(90.19 332.392 84.6503)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.159,
    cy: 379.262,
    r: 0.526652,
    transform: "rotate(90.19 167.159 379.262)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.615,
    cy: 483.891,
    r: 0.703465,
    transform: "rotate(90.19 240.615 483.891)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.568,
    cy: 310.156,
    r: 0.749249,
    transform: "rotate(90.19 358.568 310.156)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.2643,
    cy: 378.463,
    r: 0.786851,
    transform: "rotate(90.19 32.2643 378.463)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.901,
    cy: 78.5218,
    r: 0.484701,
    transform: "rotate(90.19 190.901 78.5218)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.421,
    cy: 252.49,
    r: 0.529062,
    transform: "rotate(90.19 297.421 252.49)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.63,
    cy: 372.43,
    r: 0.779831,
    transform: "rotate(90.19 145.63 372.43)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.785,
    cy: 451.328,
    r: 0.614905,
    transform: "rotate(90.19 274.785 451.328)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.676,
    cy: 240.251,
    r: 0.597742,
    transform: "rotate(90.19 318.676 240.251)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.416,
    cy: 56.1003,
    r: 0.538532,
    transform: "rotate(90.19 204.416 56.1003)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.184,
    cy: 317.198,
    r: 0.401025,
    transform: "rotate(90.19 361.184 317.198)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.9108,
    cy: 323.081,
    r: 0.446096,
    transform: "rotate(90.19 20.9108 323.081)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.506,
    cy: 449.185,
    r: 0.754392,
    transform: "rotate(90.19 322.506 449.185)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.693,
    cy: 37.1625,
    r: 0.644872,
    transform: "rotate(90.19 191.693 37.1625)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.9254,
    cy: 481.265,
    r: 0.492852,
    transform: "rotate(90.19 50.9254 481.265)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.751,
    cy: 98.421,
    r: 0.464642,
    transform: "rotate(90.19 336.751 98.421)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.317,
    cy: 422.185,
    r: 0.429397,
    transform: "rotate(90.19 198.317 422.185)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.7365,
    cy: 380.184,
    r: 0.736167,
    transform: "rotate(90.19 78.7365 380.184)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.963,
    cy: 363.359,
    r: 0.705864,
    transform: "rotate(90.19 282.963 363.359)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.703,
    cy: 8.67221,
    r: 0.657914,
    transform: "rotate(90.19 151.703 8.67221)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.126,
    cy: 96.6494,
    r: 0.730692,
    transform: "rotate(90.19 133.126 96.6494)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.55,
    cy: 369.552,
    r: 0.454137,
    transform: "rotate(90.19 104.55 369.552)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.318,
    cy: 446.625,
    r: 0.466084,
    transform: "rotate(90.19 351.318 446.625)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.47,
    cy: 145.722,
    r: 0.602709,
    transform: "rotate(90.19 302.47 145.722)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.119,
    cy: 168.813,
    r: 0.630753,
    transform: "rotate(90.19 179.119 168.813)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.0029,
    cy: 310.367,
    r: 0.570881,
    transform: "rotate(90.19 89.0029 310.367)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.766,
    cy: 518.819,
    r: 0.443384,
    transform: "rotate(90.19 249.766 518.819)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.577,
    cy: 120.806,
    r: 0.559341,
    transform: "rotate(90.19 160.577 120.806)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.026,
    cy: 497.649,
    r: 0.743894,
    transform: "rotate(90.19 176.026 497.649)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.73,
    cy: 65.698,
    r: 0.763629,
    transform: "rotate(90.19 243.73 65.698)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.8579,
    cy: 337.71,
    r: 0.653583,
    transform: "rotate(90.19 25.8579 337.71)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.26327,
    cy: 122.209,
    r: 0.43597,
    transform: "rotate(90.19 6.26327 122.209)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.129,
    cy: 50.2688,
    r: 0.464239,
    transform: "rotate(90.19 276.129 50.2688)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.259163,
    cy: 297.778,
    r: 0.473903,
    transform: "rotate(90.19 -0.259163 297.778)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.0948,
    cy: 551.467,
    r: 0.440381,
    transform: "rotate(90.19 43.0948 551.467)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.418,
    cy: 150.759,
    r: 0.609322,
    transform: "rotate(90.19 390.418 150.759)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.278,
    cy: 422.222,
    r: 0.714356,
    transform: "rotate(90.19 320.278 422.222)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5257,
    cy: 531.878,
    r: 0.456227,
    transform: "rotate(90.19 78.5257 531.878)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.852,
    cy: 364.448,
    r: 0.573962,
    transform: "rotate(90.19 375.852 364.448)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.887,
    cy: 477.711,
    r: 0.749477,
    transform: "rotate(90.19 377.887 477.711)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.406,
    cy: 352.671,
    r: 0.706337,
    transform: "rotate(90.19 139.406 352.671)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.469,
    cy: 315.116,
    r: 0.68063,
    transform: "rotate(90.19 347.469 315.116)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.518,
    cy: 352.323,
    r: 0.730926,
    transform: "rotate(90.19 228.518 352.323)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.952,
    cy: 315.41,
    r: 0.416423,
    transform: "rotate(90.19 298.952 315.41)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.417,
    cy: 27.9809,
    r: 0.446303,
    transform: "rotate(90.19 261.417 27.9809)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.31,
    cy: 310.199,
    r: 0.561215,
    transform: "rotate(90.19 196.31 310.199)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.745,
    cy: 28.9208,
    r: 0.71962,
    transform: "rotate(90.19 377.745 28.9208)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.755,
    cy: 318.481,
    r: 0.668407,
    transform: "rotate(90.19 342.755 318.481)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.9222,
    cy: 355.407,
    r: 0.406046,
    transform: "rotate(90.19 70.9222 355.407)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.22,
    cy: 64.1987,
    r: 0.469944,
    transform: "rotate(90.19 274.22 64.1987)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.168,
    cy: 94.1157,
    r: 0.794633,
    transform: "rotate(90.19 382.168 94.1157)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.377,
    cy: 414.545,
    r: 0.455366,
    transform: "rotate(90.19 140.377 414.545)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.763,
    cy: 377.63,
    r: 0.448691,
    transform: "rotate(90.19 176.763 377.63)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.317,
    cy: 312.952,
    r: 0.592332,
    transform: "rotate(90.19 195.317 312.952)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.8466,
    cy: 31.6639,
    r: 0.490168,
    transform: "rotate(90.19 47.8466 31.6639)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.981,
    cy: 4.43086,
    r: 0.619004,
    transform: "rotate(90.19 222.981 4.43086)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.769,
    cy: 453.828,
    r: 0.497276,
    transform: "rotate(90.19 130.769 453.828)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.316,
    cy: 17.0889,
    r: 0.591373,
    transform: "rotate(90.19 382.316 17.0889)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.675,
    cy: 241.402,
    r: 0.529101,
    transform: "rotate(90.19 388.675 241.402)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5278,
    cy: 219.979,
    r: 0.421497,
    transform: "rotate(90.19 92.5278 219.979)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.259,
    cy: 142.44,
    r: 0.590592,
    transform: "rotate(90.19 205.259 142.44)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8961,
    cy: 193.978,
    r: 0.731376,
    transform: "rotate(90.19 10.8961 193.978)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.132,
    cy: 307.765,
    r: 0.745435,
    transform: "rotate(90.19 338.132 307.765)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.349,
    cy: 511.183,
    r: 0.500558,
    transform: "rotate(90.19 147.349 511.183)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.7715,
    cy: 435.937,
    r: 0.511497,
    transform: "rotate(90.19 55.7715 435.937)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.8,
    cy: 74.5259,
    r: 0.533532,
    transform: "rotate(90.19 320.8 74.5259)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.205,
    cy: 56.0442,
    r: 0.701553,
    transform: "rotate(90.19 131.205 56.0442)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0255,
    cy: 281.303,
    r: 0.731316,
    transform: "rotate(90.19 11.0255 281.303)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.438,
    cy: 75.2177,
    r: 0.736585,
    transform: "rotate(90.19 206.438 75.2177)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.303,
    cy: 354.303,
    r: 0.59389,
    transform: "rotate(90.19 236.303 354.303)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.449,
    cy: 89.5382,
    r: 0.672077,
    transform: "rotate(90.19 275.449 89.5382)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.915,
    cy: 545.986,
    r: 0.423225,
    transform: "rotate(90.19 244.915 545.986)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.371,
    cy: 329.003,
    r: 0.435177,
    transform: "rotate(90.19 369.371 329.003)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.7353,
    cy: 195.725,
    r: 0.485246,
    transform: "rotate(90.19 79.7353 195.725)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.943,
    cy: 128.896,
    r: 0.57744,
    transform: "rotate(90.19 280.943 128.896)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.518,
    cy: 369.155,
    r: 0.673724,
    transform: "rotate(90.19 124.518 369.155)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.495,
    cy: 147.688,
    r: 0.649812,
    transform: "rotate(90.19 235.495 147.688)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.409,
    cy: 177.91,
    r: 0.788661,
    transform: "rotate(90.19 241.409 177.91)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.256,
    cy: 8.46171,
    r: 0.412441,
    transform: "rotate(90.19 125.256 8.46171)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.344,
    cy: 267.715,
    r: 0.656855,
    transform: "rotate(90.19 211.344 267.715)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.1063,
    cy: 305.563,
    r: 0.60262,
    transform: "rotate(90.19 43.1063 305.563)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.811,
    cy: 284.157,
    r: 0.730026,
    transform: "rotate(90.19 327.811 284.157)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.311,
    cy: 342.667,
    r: 0.666636,
    transform: "rotate(90.19 278.311 342.667)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.211,
    cy: 62.7473,
    r: 0.658453,
    transform: "rotate(90.19 126.211 62.7473)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.945,
    cy: 196.92,
    r: 0.430495,
    transform: "rotate(90.19 200.945 196.92)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.146,
    cy: 263.065,
    r: 0.46178,
    transform: "rotate(90.19 167.146 263.065)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.536,
    cy: 363.361,
    r: 0.505657,
    transform: "rotate(90.19 316.536 363.361)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.554,
    cy: 407.015,
    r: 0.599615,
    transform: "rotate(90.19 256.554 407.015)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.8354,
    cy: 312.942,
    r: 0.589429,
    transform: "rotate(90.19 84.8354 312.942)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.529,
    cy: 23.7076,
    r: 0.738552,
    transform: "rotate(90.19 196.529 23.7076)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.6171,
    cy: 287.527,
    r: 0.582587,
    transform: "rotate(90.19 99.6171 287.527)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.1533,
    cy: 61.4647,
    r: 0.518359,
    transform: "rotate(90.19 35.1533 61.4647)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.957,
    cy: 394.381,
    r: 0.763246,
    transform: "rotate(90.19 234.957 394.381)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.6535,
    cy: 78.6258,
    r: 0.423254,
    transform: "rotate(90.19 78.6535 78.6258)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.99,
    cy: 261.409,
    r: 0.623687,
    transform: "rotate(90.19 251.99 261.409)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.61,
    cy: 72.6539,
    r: 0.607629,
    transform: "rotate(90.19 376.61 72.6539)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.549,
    cy: 86.9591,
    r: 0.416294,
    transform: "rotate(90.19 190.549 86.9591)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.848,
    cy: 204.808,
    r: 0.476222,
    transform: "rotate(90.19 151.848 204.808)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.635,
    cy: 281.051,
    r: 0.531893,
    transform: "rotate(90.19 108.635 281.051)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1078,
    cy: 186.536,
    r: 0.422032,
    transform: "rotate(90.19 61.1078 186.536)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.25,
    cy: 462.265,
    r: 0.623639,
    transform: "rotate(90.19 355.25 462.265)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.985,
    cy: 102.504,
    r: 0.402498,
    transform: "rotate(90.19 319.985 102.504)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.2116,
    cy: 434.647,
    r: 0.620857,
    transform: "rotate(90.19 58.2116 434.647)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.062,
    cy: 208.826,
    r: 0.399824,
    transform: "rotate(90.19 216.062 208.826)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1177,
    cy: 206.796,
    r: 0.585003,
    transform: "rotate(90.19 12.1177 206.796)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.3,
    cy: 340.246,
    r: 0.579233,
    transform: "rotate(90.19 251.3 340.246)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9503,
    cy: 197.566,
    r: 0.703638,
    transform: "rotate(90.19 83.9503 197.566)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.304,
    cy: 448.308,
    r: 0.652595,
    transform: "rotate(90.19 111.304 448.308)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.946,
    cy: 64.5864,
    r: 0.606334,
    transform: "rotate(90.19 209.946 64.5864)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.464,
    cy: 312.248,
    r: 0.507904,
    transform: "rotate(90.19 258.464 312.248)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5224,
    cy: 76.4421,
    r: 0.477471,
    transform: "rotate(90.19 38.5224 76.4421)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.838,
    cy: 362.406,
    r: 0.594122,
    transform: "rotate(90.19 38.838 362.406)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9989,
    cy: 60.9731,
    r: 0.402063,
    transform: "rotate(90.19 75.9989 60.9731)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.209,
    cy: 106.35,
    r: 0.499671,
    transform: "rotate(90.19 334.209 106.35)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.058,
    cy: 11.2198,
    r: 0.511855,
    transform: "rotate(90.19 294.058 11.2198)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5907,
    cy: 112.448,
    r: 0.519382,
    transform: "rotate(90.19 31.5907 112.448)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.896,
    cy: 226.622,
    r: 0.428267,
    transform: "rotate(90.19 258.896 226.622)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.263,
    cy: 541.827,
    r: 0.671373,
    transform: "rotate(90.19 135.263 541.827)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.017,
    cy: 183.98,
    r: 0.55958,
    transform: "rotate(90.19 309.017 183.98)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.537,
    cy: 186.745,
    r: 0.717861,
    transform: "rotate(90.19 369.537 186.745)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.243,
    cy: 145.055,
    r: 0.580655,
    transform: "rotate(90.19 215.243 145.055)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.628,
    cy: 448.327,
    r: 0.683474,
    transform: "rotate(90.19 238.628 448.327)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.417,
    cy: 73.1359,
    r: 0.527865,
    transform: "rotate(90.19 193.417 73.1359)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5042,
    cy: 94.5015,
    r: 0.577359,
    transform: "rotate(90.19 71.5042 94.5015)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.734,
    cy: 210.727,
    r: 0.535956,
    transform: "rotate(90.19 363.734 210.727)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.33413,
    cy: 526.789,
    r: 0.570718,
    transform: "rotate(90.19 9.33413 526.789)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.831,
    cy: 436.767,
    r: 0.421643,
    transform: "rotate(90.19 387.831 436.767)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.01,
    cy: 112.717,
    r: 0.509668,
    transform: "rotate(90.19 198.01 112.717)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.447,
    cy: 94.9033,
    r: 0.628029,
    transform: "rotate(90.19 350.447 94.9033)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.044,
    cy: 360.66,
    r: 0.582106,
    transform: "rotate(90.19 134.044 360.66)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.448,
    cy: 288.441,
    r: 0.727974,
    transform: "rotate(90.19 172.448 288.441)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.876,
    cy: 14.9309,
    r: 0.648625,
    transform: "rotate(90.19 126.876 14.9309)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.26,
    cy: 38.8918,
    r: 0.435239,
    transform: "rotate(90.19 300.26 38.8918)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.412,
    cy: 258.833,
    r: 0.735467,
    transform: "rotate(90.19 377.412 258.833)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2853,
    cy: 393.354,
    r: 0.513764,
    transform: "rotate(90.19 47.2853 393.354)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.184,
    cy: 61.0508,
    r: 0.65357,
    transform: "rotate(90.19 198.184 61.0508)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.9891,
    cy: 132.631,
    r: 0.793423,
    transform: "rotate(90.19 47.9891 132.631)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.3093,
    cy: 69.5271,
    r: 0.508336,
    transform: "rotate(90.19 78.3093 69.5271)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.772,
    cy: 220.532,
    r: 0.457004,
    transform: "rotate(90.19 352.772 220.532)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.904,
    cy: 549.776,
    r: 0.520092,
    transform: "rotate(90.19 246.904 549.776)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.735,
    cy: 228.893,
    r: 0.720873,
    transform: "rotate(90.19 223.735 228.893)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.81,
    cy: 510.937,
    r: 0.778678,
    transform: "rotate(90.19 368.81 510.937)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.906,
    cy: 2.92305,
    r: 0.439686,
    transform: "rotate(90.19 287.906 2.92305)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.635584,
    cy: 465.922,
    r: 0.589029,
    transform: "rotate(90.19 0.635584 465.922)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.6,
    cy: 404.82,
    r: 0.764323,
    transform: "rotate(90.19 340.6 404.82)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.7816,
    cy: 428.094,
    r: 0.703892,
    transform: "rotate(90.19 43.7816 428.094)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.529,
    cy: 27.5557,
    r: 0.684531,
    transform: "rotate(90.19 251.529 27.5557)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.4837,
    cy: 234.247,
    r: 0.5126,
    transform: "rotate(90.19 87.4837 234.247)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6288,
    cy: 421.565,
    r: 0.517409,
    transform: "rotate(90.19 36.6288 421.565)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.594,
    cy: 307.762,
    r: 0.704869,
    transform: "rotate(90.19 372.594 307.762)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.093,
    cy: 320.938,
    r: 0.502538,
    transform: "rotate(90.19 260.093 320.938)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.88264,
    cy: 456.838,
    r: 0.580281,
    transform: "rotate(90.19 8.88264 456.838)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.791,
    cy: 245.985,
    r: 0.435058,
    transform: "rotate(90.19 243.791 245.985)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.438,
    cy: 463.386,
    r: 0.504509,
    transform: "rotate(90.19 310.438 463.386)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.9,
    cy: 475.773,
    r: 0.450233,
    transform: "rotate(90.19 119.9 475.773)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.628,
    cy: 324.996,
    r: 0.587035,
    transform: "rotate(90.19 304.628 324.996)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.19,
    cy: 401.456,
    r: 0.772658,
    transform: "rotate(90.19 130.19 401.456)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.828,
    cy: 423.254,
    r: 0.756746,
    transform: "rotate(90.19 356.828 423.254)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.151,
    cy: 112.406,
    r: 0.714863,
    transform: "rotate(90.19 140.151 112.406)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.685,
    cy: 359.269,
    r: 0.548471,
    transform: "rotate(90.19 116.685 359.269)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.104,
    cy: 476.766,
    r: 0.588258,
    transform: "rotate(90.19 298.104 476.766)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.457,
    cy: 299.495,
    r: 0.425567,
    transform: "rotate(90.19 256.457 299.495)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.221,
    cy: 430.005,
    r: 0.67792,
    transform: "rotate(90.19 274.221 430.005)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.3021,
    cy: 351.12,
    r: 0.774394,
    transform: "rotate(90.19 81.3021 351.12)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4495,
    cy: 191.766,
    r: 0.69324,
    transform: "rotate(90.19 89.4495 191.766)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.481,
    cy: 247.479,
    r: 0.4405,
    transform: "rotate(90.19 219.481 247.479)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.52,
    cy: 518.417,
    r: 0.611522,
    transform: "rotate(90.19 267.52 518.417)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.148,
    cy: 96.8217,
    r: 0.702871,
    transform: "rotate(90.19 351.148 96.8217)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.84,
    cy: 355.599,
    r: 0.423888,
    transform: "rotate(90.19 292.84 355.599)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.212,
    cy: 418.11,
    r: 0.470561,
    transform: "rotate(90.19 385.212 418.11)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5226,
    cy: 518.135,
    r: 0.639813,
    transform: "rotate(90.19 21.5226 518.135)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.664,
    cy: 360.05,
    r: 0.687937,
    transform: "rotate(90.19 180.664 360.05)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.656,
    cy: 10.4874,
    r: 0.543335,
    transform: "rotate(90.19 305.656 10.4874)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.846,
    cy: 4.07245,
    r: 0.465552,
    transform: "rotate(90.19 269.846 4.07245)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.666,
    cy: 26.9514,
    r: 0.399725,
    transform: "rotate(90.19 279.666 26.9514)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.088,
    cy: 436.643,
    r: 0.646389,
    transform: "rotate(90.19 391.088 436.643)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.6513,
    cy: 308.663,
    r: 0.765625,
    transform: "rotate(90.19 64.6513 308.663)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.7682,
    cy: 141.07,
    r: 0.41018,
    transform: "rotate(90.19 93.7682 141.07)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.583,
    cy: 363.267,
    r: 0.785814,
    transform: "rotate(90.19 127.583 363.267)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.737,
    cy: 262.901,
    r: 0.423928,
    transform: "rotate(90.19 100.737 262.901)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.6874,
    cy: 98.9722,
    r: 0.555398,
    transform: "rotate(90.19 33.6874 98.9722)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.499,
    cy: 208.11,
    r: 0.758335,
    transform: "rotate(90.19 267.499 208.11)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.854,
    cy: 328.38,
    r: 0.413477,
    transform: "rotate(90.19 291.854 328.38)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.8027,
    cy: 70.4401,
    r: 0.718339,
    transform: "rotate(90.19 57.8027 70.4401)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.849,
    cy: 272.506,
    r: 0.408137,
    transform: "rotate(90.19 258.849 272.506)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.777,
    cy: 354.574,
    r: 0.51288,
    transform: "rotate(90.19 194.777 354.574)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.89988,
    cy: 288.371,
    r: 0.611765,
    transform: "rotate(90.19 6.89988 288.371)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.085,
    cy: 113.406,
    r: 0.487479,
    transform: "rotate(90.19 155.085 113.406)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.2411,
    cy: 231.53,
    r: 0.54173,
    transform: "rotate(90.19 80.2411 231.53)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.604,
    cy: 135.743,
    r: 0.532973,
    transform: "rotate(90.19 392.604 135.743)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.465,
    cy: 130.279,
    r: 0.703638,
    transform: "rotate(90.19 385.465 130.279)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.422,
    cy: 340.887,
    r: 0.699427,
    transform: "rotate(90.19 259.422 340.887)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.7738,
    cy: 355.153,
    r: 0.787086,
    transform: "rotate(90.19 40.7738 355.153)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.1106,
    cy: 96.4548,
    r: 0.591088,
    transform: "rotate(90.19 18.1106 96.4548)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.605,
    cy: 285.376,
    r: 0.404144,
    transform: "rotate(90.19 111.605 285.376)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.275,
    cy: 502.999,
    r: 0.646706,
    transform: "rotate(90.19 106.275 502.999)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.588,
    cy: 216.6,
    r: 0.634278,
    transform: "rotate(90.19 207.588 216.6)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.989,
    cy: 91.9797,
    r: 0.493936,
    transform: "rotate(90.19 135.989 91.9797)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.543,
    cy: 29.9887,
    r: 0.72583,
    transform: "rotate(90.19 271.543 29.9887)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.534,
    cy: 191.198,
    r: 0.669326,
    transform: "rotate(90.19 236.534 191.198)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.48,
    cy: 317.982,
    r: 0.566902,
    transform: "rotate(90.19 365.48 317.982)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.655,
    cy: 331.395,
    r: 0.430831,
    transform: "rotate(90.19 139.655 331.395)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.342,
    cy: 211.983,
    r: 0.429472,
    transform: "rotate(90.19 373.342 211.983)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.05,
    cy: 262.973,
    r: 0.493837,
    transform: "rotate(90.19 108.05 262.973)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.684,
    cy: 510.869,
    r: 0.623048,
    transform: "rotate(90.19 49.684 510.869)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.6511,
    cy: 247.307,
    r: 0.551659,
    transform: "rotate(90.19 63.6511 247.307)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.914,
    cy: 230.772,
    r: 0.654411,
    transform: "rotate(90.19 208.914 230.772)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.515,
    cy: 469.797,
    r: 0.687801,
    transform: "rotate(90.19 125.515 469.797)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.47803,
    cy: 542.567,
    r: 0.410261,
    transform: "rotate(90.19 0.47803 542.567)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.309,
    cy: 221.02,
    r: 0.486202,
    transform: "rotate(90.19 225.309 221.02)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.844,
    cy: 287.87,
    r: 0.601832,
    transform: "rotate(90.19 370.844 287.87)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.343,
    cy: 99.1603,
    r: 0.579577,
    transform: "rotate(90.19 182.343 99.1603)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.209,
    cy: 84.6797,
    r: 0.439091,
    transform: "rotate(90.19 273.209 84.6797)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.644,
    cy: 273.127,
    r: 0.501545,
    transform: "rotate(90.19 234.644 273.127)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.299,
    cy: 342.743,
    r: 0.705319,
    transform: "rotate(90.19 389.299 342.743)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.95,
    cy: 142.012,
    r: 0.50864,
    transform: "rotate(90.19 156.95 142.012)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.7887,
    cy: 535.132,
    r: 0.613518,
    transform: "rotate(90.19 43.7887 535.132)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.653,
    cy: 46.7226,
    r: 0.634635,
    transform: "rotate(90.19 249.653 46.7226)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.62,
    cy: 40.3934,
    r: 0.746034,
    transform: "rotate(90.19 248.62 40.3934)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.889,
    cy: 40.2494,
    r: 0.614632,
    transform: "rotate(90.19 157.889 40.2494)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.688,
    cy: 167.125,
    r: 0.722838,
    transform: "rotate(90.19 336.688 167.125)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.0347,
    cy: 62.7786,
    r: 0.601513,
    transform: "rotate(90.19 83.0347 62.7786)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.4621,
    cy: 342.445,
    r: 0.531769,
    transform: "rotate(90.19 71.4621 342.445)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.0046,
    cy: 175.572,
    r: 0.594996,
    transform: "rotate(90.19 26.0046 175.572)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.388,
    cy: 121.206,
    r: 0.608494,
    transform: "rotate(90.19 23.388 121.206)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9369,
    cy: 459.116,
    r: 0.511144,
    transform: "rotate(90.19 73.9369 459.116)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.561,
    cy: 48.3952,
    r: 0.515589,
    transform: "rotate(90.19 258.561 48.3952)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.484,
    cy: 323.842,
    r: 0.616741,
    transform: "rotate(90.19 142.484 323.842)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.555,
    cy: 244.697,
    r: 0.718276,
    transform: "rotate(90.19 116.555 244.697)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.463,
    cy: 321.471,
    r: 0.75105,
    transform: "rotate(90.19 259.463 321.471)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5151,
    cy: 171.46,
    r: 0.620094,
    transform: "rotate(90.19 60.5151 171.46)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.454,
    cy: 478.24,
    r: 0.524528,
    transform: "rotate(90.19 259.454 478.24)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.971,
    cy: 458.5,
    r: 0.515629,
    transform: "rotate(90.19 106.971 458.5)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.46,
    cy: 481.604,
    r: 0.576245,
    transform: "rotate(90.19 208.46 481.604)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.362,
    cy: 313.774,
    r: 0.574834,
    transform: "rotate(90.19 255.362 313.774)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.3598,
    cy: 528.899,
    r: 0.713545,
    transform: "rotate(90.19 30.3598 528.899)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5173,
    cy: 381.881,
    r: 0.484473,
    transform: "rotate(90.19 18.5173 381.881)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.91,
    cy: 159.5,
    r: 0.791775,
    transform: "rotate(90.19 154.91 159.5)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.478,
    cy: 20.2495,
    r: 0.565595,
    transform: "rotate(90.19 170.478 20.2495)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.86,
    cy: 221.918,
    r: 0.441399,
    transform: "rotate(90.19 320.86 221.918)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.311,
    cy: 145.986,
    r: 0.570225,
    transform: "rotate(90.19 389.311 145.986)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.721,
    cy: 91.1911,
    r: 0.680962,
    transform: "rotate(90.19 155.721 91.1911)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.41,
    cy: 23.3682,
    r: 0.458475,
    transform: "rotate(90.19 208.41 23.3682)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.0497,
    cy: 239.329,
    r: 0.708661,
    transform: "rotate(90.19 71.0497 239.329)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.117,
    cy: 533.547,
    r: 0.555763,
    transform: "rotate(90.19 310.117 533.547)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.579,
    cy: 479.308,
    r: 0.556381,
    transform: "rotate(90.19 271.579 479.308)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.261,
    cy: 169.74,
    r: 0.62116,
    transform: "rotate(90.19 160.261 169.74)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.95,
    cy: 386.206,
    r: 0.697687,
    transform: "rotate(90.19 324.95 386.206)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.397,
    cy: 219.037,
    r: 0.6562,
    transform: "rotate(90.19 140.397 219.037)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.599,
    cy: 346.943,
    r: 0.429562,
    transform: "rotate(90.19 246.599 346.943)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.37,
    cy: 73.0379,
    r: 0.699426,
    transform: "rotate(90.19 41.37 73.0379)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.089,
    cy: 471.161,
    r: 0.646018,
    transform: "rotate(90.19 244.089 471.161)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.158,
    cy: 109.282,
    r: 0.694221,
    transform: "rotate(90.19 302.158 109.282)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.098,
    cy: 145.235,
    r: 0.505587,
    transform: "rotate(90.19 247.098 145.235)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.2048,
    cy: 397.337,
    r: 0.772616,
    transform: "rotate(90.19 15.2048 397.337)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.252,
    cy: 280.552,
    r: 0.66917,
    transform: "rotate(90.19 100.252 280.552)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.6151,
    cy: 345.158,
    r: 0.431765,
    transform: "rotate(90.19 45.6151 345.158)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.66,
    cy: 389.03,
    r: 0.655503,
    transform: "rotate(90.19 365.66 389.03)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.474,
    cy: 107.003,
    r: 0.471836,
    transform: "rotate(90.19 234.474 107.003)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.52309,
    cy: 267.874,
    r: 0.456839,
    transform: "rotate(90.19 6.52309 267.874)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.51864,
    cy: 32.3072,
    r: 0.693422,
    transform: "rotate(90.19 9.51864 32.3072)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3438,
    cy: 163.333,
    r: 0.416099,
    transform: "rotate(90.19 40.3438 163.333)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.451,
    cy: 23.1351,
    r: 0.495114,
    transform: "rotate(90.19 360.451 23.1351)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.206,
    cy: 197.537,
    r: 0.59148,
    transform: "rotate(90.19 234.206 197.537)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.85244,
    cy: 406.7,
    r: 0.647371,
    transform: "rotate(90.19 6.85244 406.7)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.7964,
    cy: 414.513,
    r: 0.455497,
    transform: "rotate(90.19 31.7964 414.513)",
    fill: "#333333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_890_9291)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.36,
    cy: 299.717,
    rx: 247.742,
    ry: 86.9917,
    transform: "rotate(-179.933 196.36 299.717)",
    fill: "#836937",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_890_9291)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_890_9291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -81,
    y: 42,
    width: 556,
    height: 556
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 555.5,
    height: 555.5,
    transform: "translate(-81 42.5)",
    fill: "url(#paint0_radial_890_9291)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_890_9291)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_890_9291)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_890_9291)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11.8728,
    y1: 42.5,
    x2: 11.8728,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.1643,
    y1: 42.5,
    x2: 58.1643,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.456,
    y1: 42.5,
    x2: 104.456,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.748,
    y1: 42.5,
    x2: 150.748,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.039,
    y1: 42.5,
    x2: 197.039,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.331,
    y1: 42.5,
    x2: 243.331,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.623,
    y1: 42.5,
    x2: 289.623,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.914,
    y1: 42.5,
    x2: 335.914,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.206,
    y1: 42.5,
    x2: 382.206,
    y2: 598,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_890_9291)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 88.5023,
    x2: 474.5,
    y2: 88.5023,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 134.794,
    x2: 474.5,
    y2: 134.794,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 181.086,
    x2: 474.5,
    y2: 181.086,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 227.377,
    x2: 474.5,
    y2: 227.377,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 273.669,
    x2: 474.5,
    y2: 273.669,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 319.961,
    x2: 474.5,
    y2: 319.961,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 366.252,
    x2: 474.5,
    y2: 366.252,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 412.544,
    x2: 474.5,
    y2: 412.544,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 458.836,
    x2: 474.5,
    y2: 458.836,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 505.127,
    x2: 474.5,
    y2: 505.127,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81,
    y1: 551.419,
    x2: 474.5,
    y2: 551.419,
    stroke: "#D0D5DD",
    strokeOpacity: 0.1,
    strokeWidth: 0.578646
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_890_9291",
    x: -122.913,
    y: 141.193,
    width: 638.548,
    height: 317.048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.766,
    result: "effect1_foregroundBlur_890_9291"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_890_9291",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(277.75 -6.62208e-05) rotate(90) scale(555.5 289.935)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_890_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 552.741,
    height: 394.073,
    fill: "white",
    transform: "translate(394 1.46643) rotate(90.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_890_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 794.787,
    height: 794.787,
    fill: "white",
    transform: "translate(394 1.46643) rotate(90.19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_890_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555.5,
    height: 555.5,
    fill: "white",
    transform: "translate(-81.25 42.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_890_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555.5,
    height: 833.25,
    fill: "white",
    transform: "translate(-81 42.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_890_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555.5,
    height: 555.5,
    fill: "white",
    transform: "translate(-81 42.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_890_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555.5,
    height: 555.5,
    fill: "white",
    transform: "translate(-81 42.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfieldMobile);
export default __webpack_public_path__ + "static/media/starfield-mobile.f4fc62728d850195c1ffd3ce5f65ab77.svg";
export { ForwardRef as ReactComponent };